<tt-page *ngIf="!!page">
    <div class="col-xs-12 sp-0 height-full" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
        </tt-card>

        <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
    </div>

    <div class="height-full" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="popurchplanning_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card>
                        <ng-container *ngTemplateOutlet="selectionCriterias"></ng-container>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid"></tt-grid>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #selectionCriterias>
    <ng-container *ngIf="!!page">
        <tt-select ttRememberId="w_popurchplanning.businessco_no" ttLabel="businessco" [(ttModel)]="page.businessco_no" (ttModelChange)="onChanged($event, 'businessco_no')" [ttData]="selectListCompanies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
        <tt-select ttRememberId="w_popurchplanning.stockplace_id" ttLabel="businessco" [(ttModel)]="page.stockplace_id" (ttModelChange)="onChanged($event, 'stockplace_id')" [ttData]="selectListStockPlaces" ttDataId="stockplace_id" ttDataName="stockplace_name"></tt-select>
        <tt-button ttText="popurchplanning_switch_po_to_purch" (ttClick)="switchChanges()" [ttSpin]="switchingPoToPurchase" ttIcon="fas fa-sync"></tt-button>
    </ng-container>
</ng-template>
